import { Loader, dom } from '@Engage.Core';
import { customTime } from './CustomTime';
export const isset = function (value) {
    return typeof (value) != "undefined" && value !== null;
};
export const setNullIfEmpty = function (value) {
    if (value == "undefined")
        return '';
    if (!value)
        return '';
    if (Object.keys(value).length === 0)
        return '';
    return value;
};
export const getCurrentUrl = function () {
    return window.location.href;
};
export const getCurrentUrlWithoutParams = function () {
    return window.location.origin + window.location.pathname;
};
export const toUpperCaseFirsLetter = function (str) {
    if (!str)
        return;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const mapToUpperFistLetterKey = function (object) {
    const upperCaseObj = {};
    Object.keys(object).forEach(property => {
        upperCaseObj[toUpperCaseFirsLetter(property)] = object[property];
    });
    return upperCaseObj;
};
/* Url manipulation */
export const getUrlParam = function (paramName) {
    const urlParams = window.location.search.substring(1).split('&');
    for (let param of urlParams) {
        const [key, ...valueParts] = param.split('=');
        const value = valueParts.join('=');
        if (decodeURIComponent(key) === paramName) {
            return decodeURIComponent(value) || '';
        }
    }
    return '';
};
export const removeQueryParams = function (url, queryParamNames) {
    const urlparts = url.split('?');
    if (urlparts.length >= 2 && Array.isArray(queryParamNames) && queryParamNames.length) {
        const urlBase = urlparts.shift();
        const queryString = urlparts.join('?');
        let pars = queryString.split(/[&;]/g);
        for (let i = 0; i < queryParamNames.length; i++) {
            const prefix = encodeURIComponent(queryParamNames[i]) + '=';
            for (let j = pars.length - 1; j >= 0; j--) {
                if (pars[j].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(j, 1);
                }
            }
        }
        url = urlBase + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
};
export const removeQueryParamFromLocationHref = function (queryParamName) {
    const url = new URL(window.location.href);
    url.searchParams.delete(queryParamName);
    history.pushState(null, document.title, url.href);
};
export const replaceHistoryState = (queryParamNames, data = {}, url = window.location.href, title = document.title) => {
    const replaceUrl = removeQueryParams(url, queryParamNames);
    window.history.replaceState(data, title, replaceUrl);
};
export const getAllUrlParams = function () {
    let params = window.location.search.substr(1);
    let pieces = params.split("&"), data = {}, i, parts;
    // process each query pair
    for (i = 0; i < pieces.length; i++) {
        parts = pieces[i].split("=");
        if (parts.length < 2) {
            parts.push("");
        }
        data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
    }
    return data;
};
export const getQueryStringParams = function (paramsNames) {
    let queryStringSegments = window.location.search.slice(1).split('&'), result = {}, isSerchFromArray = false, necessaryParams = {};
    paramsNames.forEach(function (name) {
        necessaryParams[name] = true;
    });
    for (let i = queryStringSegments.length - 1; i >= 0; i--) {
        let segment = [];
        if (queryStringSegments[i]) {
            segment = queryStringSegments[i].split('=');
            if (necessaryParams[segment[0]]) {
                try {
                    result[segment[0]] = decodeURIComponent(segment.slice(1).join('=')); // why join?
                }
                catch (e) {
                    result[segment[0]] = '';
                }
            }
        }
    }
    ;
    return result;
};
export const hasUrlParam = function (paramName) {
    return !!getUrlParam(paramName);
};
export const addParameterToURL = function (url, paramName, param) {
    // https://gist.github.com/stinoga/8101816#gistcomment-1842990
    return url
        .replace(new RegExp("([?&]" + paramName + "(?=[=&#]|$)[^#&]*|(?=#|$))"), "&" + paramName + "=" + encodeURIComponent(param))
        .replace(/^([^?&]+)&/, "$1?");
};
export const getUrl = function () {
    return location.protocol + "//" + location.host + location.pathname;
};
export const getFileName = function (url = window.location.href) {
    return url.substring(url.lastIndexOf("/") + 1);
};
export const getQueryParamByName = function (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const getCurPageName = function () {
    return location.pathname.substring(1);
};
export const getSubdomains = function (url = document.location.origin) {
    let urlParts = url.split(".");
    urlParts = urlParts.slice(0, -2);
    if (urlParts.length) {
        let str = urlParts[0].substring(urlParts[0].lastIndexOf("/") + 1);
        if (str === "www") {
            urlParts.shift();
        }
        else {
            urlParts[0] = str;
        }
    }
    return urlParts;
};
/* /End Url manipulation */
function getTimeInterval(type) {
    switch (type) {
        case 's': return 1000;
        case 'm': return 60 * 1000;
        case 'h': return 60 * 60 * 1000;
        case 'd': return 24 * 60 * 60 * 1000;
        case 'w': return 7 * 24 * 60 * 60 * 1000;
        default: return 0;
    }
}
export const addTimeIntervalToDate = function (milliseconds = 0, date = customTime.get()) {
    let futureDate = new Date(date.valueOf());
    return futureDate.setMilliseconds(futureDate.getMilliseconds() + milliseconds);
};
export const getAllLinks = function ($html) {
    return dom.find("[href]:not([data-dismiss])", $html);
};
export const versionNumber = "#{__Version__}#";
export const dateDiff = function (dateMore, dateLess, type) {
    let diffDate = dateMore.getTime() - dateLess.getTime();
    switch (type) {
        case 's':
        case 'm':
        case 'h':
        case 'd':
            return diffDate / getTimeInterval(type);
        case 'w':
            return Math.round(diffDate / getTimeInterval(type));
        case 'M':
            let nYears = (dateMore.getFullYear() - dateLess.getFullYear());
            return dateMore.getMonth() - dateLess.getMonth() + (nYears !== 0 ? nYears * 12 : 0);
        case 'Y':
            return dateMore.getFullYear() - dateLess.getFullYear();
    }
};
export const decodeAuthCookie = function (data) {
    if (!data) {
        return null;
    }
    return encodeURIComponent(decodeURIComponent(data));
};
export const getVersion = function () {
    const version = '#{__Version__}#';
    return 'Version: ' + (version !== '#{__Version__}#' ? version : 'local');
};
export const getVersionInfo = function () {
    const version = '#{__Version__}#';
    const build = '#{__Build.BuildNumber__}#';
    return 'Version: ' + (version !== '#{__Version__}#' ? version : 'local')
        + ', Build: ' + (build !== '#{__Build.BuildNumber__}#' ? build : 'local');
};
export function flip(fn) {
    if (typeof fn !== 'function') {
        throw new TypeError('Expected a function');
    }
    return function (...args) {
        return fn.apply(this, args.reverse());
    };
}
export function safeStringify(object) {
    return JSON.stringify(object);
}
function censor(object) {
    let i = 0;
    return (key, value) => {
        if (i !== 0 && typeof (object) === 'object' && typeof (value) === 'object' && object === value)
            return '[Circular]';
        if (i >= 29) // seems to be a harded maximum of 30 serialized objects?
            return '[Unknown]';
        ++i; // so we know we aren't using the original object anymore
        return value;
    };
}
export function getUTCDateInTimezone(date = customTime.get()) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}
export function lowerCaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
export function upperCaseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export function generateGuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}
export function addDays(numberDays, date) {
    date = date ? date : customTime.get();
    date.setDate(date.getDate() + numberDays);
    return date;
}
export function uriEncodeIfNeeded(val) {
    try {
        if (decodeURIComponent(val) === val) {
            return encodeURIComponent(val);
        }
        else {
            return val;
        }
    }
    catch (_a) {
        return val;
    }
}
function attachResource(type, options, async) {
    return new Promise((resolve, reject) => {
        const head = document.getElementsByTagName('head').item(0);
        const element = document.createElement(type);
        if (async) {
            element.onload = function () {
                resolve(); // ✅ now correct
            };
            element.onerror = function (e) {
                reject(e);
            };
        }
        for (let key in options) {
            element[key] = options[key];
        }
        head.appendChild(element);
        if (!async) {
            resolve(); // ✅ now correct
        }
    });
}
export function loadResource(type, options) {
    return attachResource(type, options, false);
}
export function loadResourceAsync(type, options) {
    return attachResource(type, options, true);
}
export function getDateValueFromTimestamp(timestamp) {
    return timestamp * 1000;
}
export const addCustomEventListener = function (element, eventName, callback, options = false) {
    const listener = function (e) {
        if (e.type !== eventName) {
            return; // ie/edge bug
        }
        callback.call(element, e);
    };
    element.addEventListener(eventName, listener, options);
    return listener;
};
export function parseDateTimeOffsetToDate(dateTimeOffset) {
    let date = new Date(dateTimeOffset.replace('/Date(', '').replace(')/', ''));
    if (isNaN(date.getDate())) {
        date = new Date(parseInt(dateTimeOffset.replace('/Date(', '').replace(')/', '')));
    }
    return date;
}
export function replacePropertyValuesInObject(object, replaceableValue, newValue) {
    if (object === undefined || object === null) {
        return;
    }
    if (Array.isArray(object)) {
        object.forEach(item => replacePropertyValuesInObject(item, replaceableValue, newValue));
        return object;
    }
    Object.keys(object).forEach(key => {
        if (typeof object[key] === 'object') {
            object[key] = replacePropertyValuesInObject(object[key], replaceableValue, newValue);
            return;
        }
        if (object[key] === replaceableValue) {
            object[key] = newValue;
        }
    });
    return object;
}
export function jsonClone(object) {
    return JSON.parse(JSON.stringify(object));
}
export function createPromise(handler) {
    let resolve, reject;
    const promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
        if (handler)
            handler(resolve, reject);
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}
// custom popup function.
export function forceRegister(configurationsettings) {
    var _a, _b;
    // Disable page scroll
    const backdrop = document.createElement("div");
    backdrop.className = "ga-paywall-backdrop";
    document.body.style.overflow = "hidden";
    // Modal HTML with message + image
    let popUp = `
    <div data-display-type="modal" class="Mg2-connext modal fade in x-editable-text viewportMobile" 
         style="width: 400px;" 
         data-width="400">
        <div class="modal-body">
            <div class="contener container-fluid">
                <div class="custom-tmpl-wrapper x-editable-css-bg" id="demo-modal-a">
                    <style>
                        .Mg2-connext.modal .newsletter_main-container {
                            text-align: center;
                            padding: 2em 2.5em;
                            font-family: "SFUIText", Helvetica, Arial, sans-serif;
                        }

                        .Mg2-connext.modal .newsletter-image-container {
                            margin-bottom: 1.5em;
                        }

                        .Mg2-connext.modal .newsletter-image-container img {
                            max-width: 100px;
                            height: 100px !important;
                        }

                        .Mg2-connext.modal .newsletter-text-message {
                            color: #161618;
                            font-size: 1.2em;
                            font-weight: 500;
                            line-height: 1.5em;
                            margin-bottom: 1.5em;
                        }

                        .Mg2-connext.modal .newsletter-text-login {
                            color: #286deb;
                            cursor: pointer;
                        }

                        @media (max-width: 576px) {
                            .Mg2-connext.modal .newsletter_main-container {
                                padding: 1.2em;
                            }

                            .Mg2-connext.modal .newsletter-text-message {
                                font-size: 1em;
                            }
                        }
                    </style>
                    <div class="newsletter_main-container">
                        <div class="newsletter-image-container">
                            <img src="https://prodmg2.blob.core.windows.net/connext/upload_images/100010gift-hand-present-icon.svg" alt="Gift Icon" />
                        </div>
                        <p class="newsletter-text-message">
                            You've received a gifted article. Please 
                            <span class="newsletter-text-login" data-mg2-action="register">register</span> 
                            or <span class="newsletter-text-login" data-mg2-action="login">log in</span> to continue reading.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
    const forceRegisterTemplate = ((_b = (_a = configurationsettings === null || configurationsettings === void 0 ? void 0 : configurationsettings.Settings) === null || _a === void 0 ? void 0 : _a.ForceRegistrationForm) === null || _b === void 0 ? void 0 : _b.Html) || popUp;
    // Create wrapper div with modal-scrollable class
    const modalWrapper = document.createElement("div");
    modalWrapper.className = "ga-paywall";
    modalWrapper.innerHTML = forceRegisterTemplate;
    // Append to body
    dom.append(dom.queryElement("body"), backdrop);
    dom.append(dom.queryElement("body"), modalWrapper);
}
export function privatePopUp(data) {
    let popUp = `<div id="popup-modal" class="engage-popup">
    <div class="modal-popup-body animated bounce">
    <a class="modal-close show-engage-popup">×</a>
    <div class="modal-text">
    <p>${data}</p>
    </div>
    <div class="modal-popup-footer">
    <button class="modal-input modal-confirm">Ok</button>
    </form>
    </div>
    </div>
    `;
    let alertElement;
    alertElement = dom.create(popUp);
    dom.append(dom.queryElement("body"), alertElement);
    dom.on(".modal-close", "click", (e) => {
        dom.css(dom.find(".engage-popup", "body"), {
            'display': 'none'
        });
        return false;
    });
    dom.on(".modal-confirm", "click", (e) => {
        dom.css(dom.find(".engage-popup", "body"), {
            'display': 'none'
        });
        return true;
    });
}
// gift Article custom functions.
export function showLoader(selector) {
    const loaderElement = dom.find(selector, dom.queryElement('body'));
    const loader = new Loader(loaderElement);
    loader.on();
    return loader;
}
export function hideLoader(loader) {
    loader.off();
}
